<template>
    <div class="btn">
       <span>
         {{text}}
       </span>
    </div>
</template>

<script>
    export default {
        name: "btn",
        props:['text']
    }
</script>

<style lang="scss" scoped>
    .btn{
        span{
            display: inline-block;
            height:28px;
            width:140px;
            line-height: 28px;
            font-size: 13px;
            cursor: pointer;
            position: relative;
            -webkit-transition: all 2s;
            transition: all 2s;
            padding: 5px 13px;
            background-color: #F4A000;
            border-radius: 20px;
            position: relative;
            overflow: hidden;
            color:white;
            background-repeat: no-repeat;
        }
        span::before{
            content: "";
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient( 120deg, transparent, rgba(146, 148, 248, 0.8), transparent );
            transition: all 650ms;
        }
        span:hover::before{
            left: 100%;
        }
    }
</style>